<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-icon medium class="mr-2" v-on="on" v-on:click.stop="open = true" data-cy="userPermissions">mdi-lock
      </v-icon>
      <v-dialog v-model="open" max-width="760" v-bind:persistent="!permissionsLocked">
        <v-card>
          <v-card-title class="headline">{{
            $t("settings.editPermissions")
            }}</v-card-title>
          <v-card-text><b>{{ item.name }} ({{ item.email }})</b></v-card-text>
          <v-card-text>
            <p v-if="permissionsLocked" class="red--text">
              <v-icon color="red" x-small class="mr-1 mb-1">mdi-lock</v-icon>
              {{ $t("settings.permissionsLocked") }}
            </p>
            <accessRolePicker
              v-model="item.accessRole"
              :disabled="permissionsLocked || loading"
            />
            <template v-if="!hadRole && !item.accessRole">
              <v-row>
                <v-col cols="6">
                  <v-checkbox v-for="permission in permissionsLeft" v-bind:key="permission"
                    v-bind:label="$t(`settings.permissions.${permission}`)" v-model="item.permissions"
                    v-bind:value="permission" v-bind:disabled="permissionsLocked || loading" hide-details />
                </v-col>
                <v-col cols="6">
                  <v-checkbox v-for="permission in permissionsRight" v-bind:key="permission"
                    v-bind:label="$t(`settings.permissions.${permission}`)" v-model="item.permissions"
                    v-bind:value="permission" v-bind:disabled="permissionsLocked || loading" hide-details />
                </v-col>
              </v-row>
              <v-divider class="my-4" />
              <v-checkbox
                v-model="item.readOnly"
                :label="$t('settings.readOnly')"
                hide-details
                :disabled="permissionsLocked || loading"
                data-cy="readOnly"
              />
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text v-on:click="open = false">{{ $t("general.cancel") }}
            </v-btn>
            <v-btn v-if="!permissionsLocked" v-bind:loading="loading" color="error" text v-on:click="save()"
              data-cy="deleteEvent">{{ $t("general.save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <span>{{ $t("settings.editPermissions") }}</span>
  </v-tooltip>
</template>
<script>
import accessRolePicker from "../../formSlotComponents/user/accessRolePicker.vue";
import { levelFor } from "../../../utils/access";

export default {
  props: ["item"],
  components: { accessRolePicker },
  data: () => ({
    open: false,
    loading: false,
    hadRole: false,
    permissionsLeft: [
      "inspection",
      "instruction",
      "riskassessment",
      "usermanagement",
      "incidentreport",
      "multiusermanagement",
    ],
    permissionsRight: [
      "operatinginstruction",
      "medkitlog",
      "managedinstruction",
      "documentmanagement",
      "dangerousgoodstorage",
      "examination",
      "environmentalreport",
    ],
  }),
  watch: {
    open(value) {
      if (value) this.hadRole = !!this.item.accessRole;
    },
  },
  computed: {
    permissionsLocked() {
      const thisUser = JSON.parse(localStorage.getItem("userData"));
      if (thisUser._id === this.item._id) return true;
      if (this.item.role === "MultiUser") return true;
      if (["Owner", "Admin", "MultiUser"].includes(thisUser.role)) return false;
      if (!thisUser.access) return true;
      return !["A", "V"].includes(levelFor("users"));
    },
  },
  methods: {
    save() {
      if (this.permissionsLocked) return;

      this.loading = true;
      this.$store
        .dispatch(
          "updateUser",
          this.item.accessRole
            ? {
                _id: this.item._id,
                id: this.item.id || this.item._id,
                accessRole: this.item.accessRole,
              }
            : { ...this.item, accessRole: undefined }
        )
        .then(() => {
          this.loading = false;
          this.open = false;
        });
    },
  },
};
</script>
